import sortBy from 'lodash/sortBy'
import { SingleSessionResult } from '@mc/api'
import type { TaskType, Camp } from '../types'

const ONE_DAY_IN_MILLIS = 86400000

const dateDaysFromNow = (additionalDays?: number): Date => {
  if (!additionalDays) {
    return new Date()
  }

  const now = new Date()
  return new Date(now.getTime() + ONE_DAY_IN_MILLIS * additionalDays)
}

const tryDate = (dateStr?: string) => (dateStr ? new Date(dateStr) : undefined)

export const presentSession = (session: SingleSessionResult): Camp => ({
  ...session,
  id: session.id.toString(),
  launchDate: tryDate(session.launchDate),
  duration: session.totalDurationDays,
  images: {
    primary2x3: session.primary2x3,
    primary16x9: session.primary16x9,
    nameplateImage: session.nameplateSvg,
  },
  modules: sortBy(session.campModules, (module) => module.position).map(
    (module) => ({
      ...module,
      number: module.position,
      id: module.id?.toString(),
      name: module.title,
      marketing3x2: module.marketing3x2,
      tasks: module.campTasks
        ? sortBy(module.campTasks, (task) => task.position).map((task) => ({
            ...task,
            slug: task.slug ?? '',
            title: task.title ?? '',
            id: task.id?.toString() ?? '',
            description: task.description ?? '',
            dueDate: dateDaysFromNow(task.dueFromCampStartDays),
            // api returns 0 for duration when it should be null
            duration: task.durationSecs || undefined,
            image: {
              src: task.thumbUrl ?? '',
              alt: '',
            },
            index: task.position ?? 0,
            type: task.taskType as TaskType,
            status: 'incomplete',
          }))
        : [],
      timeLimit: dateDaysFromNow(module.dueFromCampStartDays),
      totalProjects: module.totalProjects,
      totalVideos: module.totalVideos,
      unlockDate: dateDaysFromNow(module.dueFromCampStartDays),
    }),
  ),
  competencies:
    session.competencies?.map((competency) => ({
      ...competency,
      items: competency.items ?? [],
      id: competency.id?.toString(),
    })) ?? [],
  instructors:
    session.instructors?.map((instructor) => ({
      ...instructor,
      primary1x1: instructor.headshotUrl,
      primary1x1AltText: instructor.name,
    })) ?? [],
})
